import styled from "styled-components";

export const ContainerBody = styled.div`
  min-height: 85vh;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  overflow: scroll;
`;
